import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { ScheduleAction } from '@cbridge-packages/schedule';
import { ScheduleIntervalAction } from '@cbridge-packages/schedule-interval';

export const reloadScheduleAfterIntervalUpdateEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    ScheduleIntervalAction.update.done,
  ),
  map(({ payload }) => {
    const { params: { scheduleId } } = payload;

    return ScheduleAction.load.started({ scheduleId });
  }),
);
